module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("lWQgD"))).then(() => parcelRequire('5isYx'));